export const PermissionStamps = {
    PUT: "mgr-stamps-**-PUT",
    POST: "mgr-stamps-POST",
    DELETE: "mgr-stamps-**-DELETE",
    GET: "mgr-stamps-GET",
    GET_UUID: "mgr-stamps-**-GET"
};